import { z } from 'zod';

import { TypeProcess } from '../models/contentful-generated';
import { ContentfulAssetSchema } from './contentful-asset.validator';
import { ContentfulDocumentSchema } from './contentful-document.validator';
import { ContentfulSysSchema } from './contentful-sys.validator';
import { SeoMetadataEntrySchema } from './seo-metadata.validator';

export const ProcessEntrySchema = z.object({
  sys: ContentfulSysSchema,
  fields: z.looseObject({
    slug: z.string(),
    name: z.string().optional().nullable(),
    shortDescription: ContentfulDocumentSchema.optional().nullable(),
    description: ContentfulDocumentSchema.optional().nullable(),
    image: ContentfulAssetSchema.optional().nullable(),
    maxRelatedBrands: z.number().int().optional().nullable(),
    seoMetadata: SeoMetadataEntrySchema.optional().nullable()
  }),
  metadata: z
    .object({
      tags: z.array(z.any()).optional().nullable()
    })
    .optional()
    .nullable()
});

export function validateProcessEntry(data: TypeProcess) {
  return ProcessEntrySchema.safeParse(data);
}

/**
 * Returns validation result.
 *
 * @param data
 */
export function validateProcessEntries(data: TypeProcess[]) {
  return z.array(ProcessEntrySchema).safeParse(data);
}

/**
 * Returns valid entries only. In most cases, this is preferred,
 * It allows us to still show some entries instead of showing nothing when only a single entry is invalid.
 *
 * @param data
 */
export function validateAndFilterProcessEntries(data: TypeProcess[]) {
  if (!data) return [];

  return data.reduce((acc: TypeProcess[], entry) => {
    const validationResult = validateProcessEntry(entry);
    if (validationResult.success) {
      acc.push(validationResult.data as unknown as TypeProcess);
    } else {
      console.warn(
        `Validation failed for process entry with id: '${entry?.sys?.id}'. It will be filtered out. Error: ${validationResult.error.message}`
      );
    }
    return acc;
  }, []);
}
